import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import usePatientAnalyses from 'hooks/usePatientAnalyses';
import { patientAnalysesSelectors } from "features/patientAnalyses";

const PatientAnalysesList = () => {
  const { getPatientAnalyses } = usePatientAnalyses();
  const { data, pagination } = useCustomSelector(patientAnalysesSelectors.getPatientAnalysesData);
  const fetching = useCustomSelector(patientAnalysesSelectors.patientAnalysesIsFetching);

  return (
     <BaseAnalysesList
      fetchData={getPatientAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <PatientAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);